import { StyleSheet } from 'aphrodite/no-important';
import { color, fontWeight } from '../styles/vars';
import { media } from '../styles/constants';

export const styles = StyleSheet.create({
	item: {
		marginBottom: '30px'
	},
	overlay: {
		position: 'relative'
	},
	image: {
		width: '100%',
		display: 'block',
		height: '100%',
		borderRadius: '2px'
	},
	imageLink: {
		display: 'block'
	},
	playIcon: {
		position: 'absolute',
		bottom: '0',
		minWidth: '35px',
		height: '45px',
		display: 'inline-flex',
		alignItems: 'center',
		paddingLeft: '10px'
	},
	durationContainer: {
		position: 'absolute',
		left: '34px',
		top: '11px'
	},
	duration: {
		backgroundColor: 'rgba(0, 0, 0, 0.75)',
		height: '18px',
		position: 'relative',
		fontSize: '10px',
		fontWeight: fontWeight.bold,
		color: color.white,
		paddingLeft: '6px',
		paddingRight: '5px',
		borderTopRightRadius: '2px',
		borderBottomRightRadius: '2px',

		':after': {
			content: '""',
			position: 'absolute',
			width: '18px',
			top: '0',
			bottom: '0',
			right: '100%',
			backgroundColor: 'transparent',
			borderTopRightRadius: '25% 11px',
			borderBottomRightRadius: '25% 11px',
			boxShadow: '14px 0px 0px 0px rgba(0, 0, 0, 0.75)',
			clip: 'rect(0px, 18px, 18px, 0px)'
		}
	},
	zIndexOne: {
		zIndex: '1'
	},
	meta: {
		display: 'flex',
		justifyContent: 'space-between',
		marginTop: '5px'
	},
	titleHeader: {
		margin: '0'
	},
	titleLink: {
		fontSize: '12px',
		fontWeight: fontWeight.semibold,
		lineHeight: '1.5em',
		color: color.darkGray,
		textDecoration: 'none',
		display: 'block',

		':hover': {
			color: color.darkBlue
		},

	},

	titleShowLink: {
		fontSize: '14px',
		fontWeight: fontWeight.semibold,
		lineHeight: '1.5em',
		color: color.white,
		textDecoration: 'none',
		display: 'block',

		[media.TABLET]: {
			fontSize: '12px',
		},

		[media.MOBILE]: {
			fontSize: '11px',
			color: '#3c3d48',
			fontWeight: '500',
			padding: '0 5px',
		},
	},

	titleLinkLarge: {
		fontSize: '14px',
		lineHeight: '1.43em'
	},
	props: {
		marginTop: '6px',
		fontSize: '10px',
		lineHeight: '1.43em',
		color: color.gray,
		display: 'flex',
		alignItems: 'center',
		fontWeight: '500'
	},
	propsShow: {
		[media.MOBILE]: {
			display: 'none'
		}
	},
	category: {
		marginRight: '5px',
		':before': {
			content: '"|"',
			margin: '0 5px'
		}
	},
	categoryLogoContainer: {
		marginLeft: '10px'
	},
	categoryLogo: {
		width: '50px'
	},

	showItem: {
		[media.MOBILE]: {
			minWidth: '165px',
			minHeight: '150px',
			backgroundColor: 'white',
			color: '#3c3d48',
			padding: '5px',
			margin: '5px',
			borderRadius: '2px',
			display: 'inline-block',
			boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.1)'
		},

		[media.SMALL]: {
			minWidth: '140px',
			minHeight: '145px'
		}
	},
});



// WEBPACK FOOTER //
// ./react-app-src/shared/components/videoItemStyles.js